/* istanbul ignore file */
import { predicateValueEditorStyle, labelsCellItemStyle, labelsCellScopeStyle } from '@bingads-webui-campaign-react/common-styles';
import { Constants } from '@bingads-webui-theme-2018/theme-fluent';

export const getLabelStyle = ({ palette, semanticColors }) => ({
  '.labels-selector .column-tri-state-checkbox': {
    '& span:hover:before': {
      fontFamily: 'MsAds MDL2 Assets !important',
      paddingLeft: '1px',
      fontSize: 16,
      lineHeight: '16px',
    },
  },
  '.labels-selector.two-state-selector .column-tri-state-checkbox': {
    '& span:hover:before': {
      content: '"\\E73E"',
    },
  },
  '.labels-selector.tri-state-selector .column-tri-state-checkbox': {
    '& span:hover:before': {
      content: '"\\E73C"',
    },
  },
  '.dropdown.open .labels-selector': predicateValueEditorStyle.selector({ palette }),
  '.labels-selector .nameTemplate': {
    display: 'flex',
    transform: 'translateY(-1px)',
    ...labelsCellScopeStyle('16px', -1),
  },
  '.k-overlay': {
    position: 'fixed',
    top: '0',
    left: '0',
    zIndex: '800',
    width: '100%',
    height: '100%',
    backgroundColor: '#fff',
    opacity: '.4',
    filter: 'alpha(opacity=40)',
  },
  'div.k-window': {
    width: '450px',
    display: 'block',
    position: 'absolute',
    zIndex: '999',
    background: semanticColors.bodyBackground,
    border: '1px solid #d9d9d9',
    boxShadow: '0 6.4px 14.4px 0 rgba(0,0,0,.132), 0 1.2px 3.6px 0 rgba(0,0,0,.108)',
    padding: '22px 24px 15px 24px',
    boxSizing: 'content-box',
  },
  'div.k-window-content': {
    height: '100%',
    overflow: 'auto',
  },
  '.k-i-close:before': {
    content: '"\\E711"',
  },
  '.k-i-close': {
    fontFamily: '"MsAds MDL2 Assets"',
    fontSize: 14,
    fontStyle: 'normal',
    W: 'antialiased',
    M: 'grayscale',
    fontWeight: 'normal',
    lineHeight: '1',
    position: 'relative',
  },
  '.k-window-actions': {
    float: 'right',

    '& a.k-window-action.k-link.clickable:focus': {
      outline: 'auto',
    },
  },
  '.k-window-content.k-content': {
    '& a.HelpTopic:focus': {
      outline: 'auto',
    },
    '& .save-bar.segment-alert-ok': {
      '& input.btn-default:focus': {
        outline: 'auto',
      },
    },
  },
  'span.k-window-title': {
    fontSize: 20,
    display: 'inline-block',
  },
  '.create-label': {
    paddingTop: 26,
    marginBottom: '0',

    '& .create-label__name-field': {
      boxSizing: 'border-box',
    },
    '& .create-label__actions': {
      marginTop: 20,
      marginBottom: 14,
      padding: 0,

      '& .create-label__action': {
        borderRadius: 2,
      },
      '& .create-label__action.btn-default': {
        marginLeft: 8,
      },
    },
  },
  '.k-window-titlebar.k-header': {
    paddingTop: 15,
  },
  '.popover-view': {
    background: '#ffffff',
    border: 'solid 1px #606060',
  },
  '.popover-view__content': {
    fontSize: 12,
  },
  '.popover-view.popup--labels': {
    width: 394,
    padding: '17px 28px 20px 24px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.2)',
    border: 'none',
    position: 'relative',
    zIndex: Constants.ZIndexContentComponents.StatusPopup,
  },
  '.popup--labels .popup__close': {
    padding: 0,
    marginTop: -5,
    marginRight: -5,
  },

  '.popup--labels__entity-type': {
    fontWeight: 'bold',
    fontSize: 20,
    lineHeight: '28px',
  },
  '.popup--labels__entity-type + span': {
    fontWeight: 'bold',
    fontSize: 20,
    lineHeight: '28px',
    overflowWrap: 'break-word',
  },
  '.popup--labels__container': {
    marginTop: 10,
    ...labelsCellItemStyle(),
  },
  '.popup--labels__actions': {
    marginTop: 10,
    fontSize: 14,
  },
});
